import React from 'react';
import getThemeLookup from '../selectors/getThemeLookup';
import { useAppSelector } from '../app/hooks';

//@ts-ignore
import { UilAngleRight } from '@iconscout/react-unicons';

const SubSectionChevron = () => {
  const p = useAppSelector(getThemeLookup);

  return (
    <div style={styles.chevronWrapper}>
      <UilAngleRight color={p('chevron', ['color']).color} />
    </div>
  );
};

export default SubSectionChevron;

const styles: Styles = {
  chevronWrapper: {
    marginRight: -8,
  },
};
